import { matchPath } from 'react-router';

export enum RoutePath {
    Root = '/',
    Packs = '/packs/',
    PackEdit = '/pack/:id',
    PackNew = '/newpack',
    PortalLibrary = '/portal/library',
    PortalPublication = '/portal/publication',
    PortalPolls = '/portal/polls',
    PortalPostEdit = '/portal/post/:id',
    PortalPostNew = '/portal/post/new',
    PortalSettings = '/portal/settings',
    PortalTranslations = '/portal/translations',
    Login = '/login',
    Gifts = '/gifts/',
    GiftEdit = '/gift/:id',
    GiftNew = '/newgift',
    GiftsV2 = '/giftsv2/',
    GiftsV2Planner = '/giftsv2/planner',
    GiftsV2Scheduler = '/giftsv2/scheduler',
    GiftsV2Library = '/giftsv2/library',
    Maps = '/maps/',
    MapEdit = '/map/:id',
    Carousels = '/carousels/',
    CarouselEdit = '/carousel/:id',
    CarouselNew = '/newcarousel',
    Tabs = '/shoptabs/',
    TabEdit = '/shoptab/:id',
    TabNew = '/newshoptab',
    AccountManagement = '/manage/',
    GroupedProfiles = '/grouped-profiles',
    Versions = '/versions/',
    Medias = '/medias',
    PriceAutomationApple = '/price-automation-apple/',
    PriceAutomationGoogle = '/price-automation-google/',
    SKUManagement = '/sku-management',
    Tools = '/tools',
    InAppEvents = '/iaes/',
    InAppEventsEdit = '/iae/:id',
    InAppEventsNew = '/newiae',
    Tags = '/tags',
    TagEdit = '/tags/:id',
    TagNew = '/newtag',
    Banners = '/banners',
    BannerEdit = '/banners/:id',
    BannerNew = '/newbanner',
    Activations = '/activations',
    Events = '/events',
    UserManagement = '/users',
    EmailAuditList = '/email-audit',
    EmailAuditItem = '/email-audit/:id',
}

export const RouteTo = {
    Root: () => RoutePath.Root,
    PortalLibrary: () => RoutePath.PortalLibrary,
    PortalPublication: () => RoutePath.PortalPublication,
    PortalPolls: () => RoutePath.PortalPolls,
    PortalPostEdit: (id: string) => RoutePath.PortalPostEdit.replace(':id', id),
    PortalPostNew: () => RoutePath.PortalPostNew,
    PortalSettings: () => RoutePath.PortalSettings,
    PortalTranslations: () => RoutePath.PortalTranslations,
    Packs: () => RoutePath.Packs,
    PackEdit: (id: string) => RoutePath.PackEdit.replace(':id', id),
    PackNew: () => RoutePath.PackNew,
    Login: (redirectTo?: string) => {
        return redirectTo
            ? `${RoutePath.Login}?redirectTo=${redirectTo}`
            : RoutePath.Login;
    },
    Gifts: () => RoutePath.Gifts,
    GiftEdit: (id: string) => RoutePath.GiftEdit.replace(':id', id),
    GiftNew: () => RoutePath.GiftNew,
    GiftsV2: () => RoutePath.GiftsV2,
    GiftsV2Planner: () => RoutePath.GiftsV2Planner,
    GiftsV2Scheduler: () => RoutePath.GiftsV2Scheduler,
    GiftsV2Library: () => RoutePath.GiftsV2Library,
    Maps: () => RoutePath.Maps,
    MapEdit: (id: string) => RoutePath.MapEdit.replace(':id', id),
    Carousels: () => RoutePath.Carousels,
    CarouselEdit: (id: string) => RoutePath.CarouselEdit.replace(':id', id),
    CarouselNew: () => RoutePath.CarouselNew,
    Tabs: () => RoutePath.Tabs,
    TabEdit: (id: string) => RoutePath.TabEdit.replace(':id', id),
    TabNew: () => RoutePath.TabNew,
    AccountManagement: () => RoutePath.AccountManagement,
    GroupedProfiles: () => RoutePath.GroupedProfiles,
    Versions: () => RoutePath.Versions,
    Medias: () => RoutePath.Medias,
    Banners: () => RoutePath.Banners,
    BannerEdit: (id: string) => RoutePath.BannerEdit.replace(':id', id),
    BannerNew: () => RoutePath.BannerNew,
    PriceAutomationApple: () => RoutePath.PriceAutomationApple,
    PriceAutomationGoogle: () => RoutePath.PriceAutomationGoogle,
    SKUManagement: () => RoutePath.SKUManagement,
    Tools: () => RoutePath.Tools,
    InAppEvents: () => RoutePath.InAppEvents,
    InAppEventsEdit: (id: string) =>
        RoutePath.InAppEventsEdit.replace(':id', id),
    InAppEventsNew: () => RoutePath.InAppEventsNew,
    Tags: () => RoutePath.Tags,
    TagEdit: (id: string) => RoutePath.TagEdit.replace(':id', id),
    TagNew: () => RoutePath.TagNew,
    Activations: () => RoutePath.Activations,
    Events: () => RoutePath.Events,
    UserManagement: () => RoutePath.UserManagement,
    EmailAuditList: () => RoutePath.EmailAuditList,
    EmailAuditItem: (id: string) => RoutePath.EmailAuditItem.replace(':id', id),
};

export function getRouteByUrl(url: string): keyof typeof RoutePath | undefined {
    for (const [name, path] of Object.entries(RoutePath)) {
        if (matchPath(path, url) !== null) {
            return name as keyof typeof RoutePath;
        }
    }

    return undefined;
}
